import React from 'react'

interface InfoWindowData {
  collation: any
}

interface MapInteractionsProps {
  infoWindow: InfoWindowData | null
  setInfoWindow: (infoWindow: InfoWindowData | null) => void
  onMoveToTour: (
    currentTourId: string,
    newTourId: string,
    collationId: string,
  ) => void
  onHideTour: (tourId: string) => void
}

export default function useMapInteractions({
  infoWindow,
  setInfoWindow,
  onMoveToTour,
  onHideTour,
}: MapInteractionsProps) {
  React.useEffect(() => {
    const handleInfoWindowClick = (event: Event) => {
      const target = event.target as HTMLElement
      if (target.closest('.move-tour')) {
        event.preventDefault()
        event.stopPropagation()

        const moveButton = target.closest('.move-tour') as HTMLElement
        const tourId = moveButton.getAttribute('data-tour-id')
        const newTourId = moveButton.getAttribute('data-new-tour-id')
        const collationId = moveButton.getAttribute('data-collation-id')

        if (tourId && newTourId && collationId) {
          onMoveToTour(tourId, newTourId, collationId)
          // Close info window after action
          setInfoWindow(null)
        }
      } else if (target.closest('.hide-tour')) {
        event.preventDefault()
        event.stopPropagation()

        const hideButton = target.closest('.hide-tour') as HTMLElement
        const tourId = hideButton.getAttribute('data-tour-id')
        if (tourId) {
          onHideTour(tourId)
          // Close info window after action
          setInfoWindow(null)
        }
      }
    }

    document.addEventListener('click', handleInfoWindowClick, true)
    return () =>
      document.removeEventListener('click', handleInfoWindowClick, true)
  }, [onMoveToTour, onHideTour, infoWindow, setInfoWindow])
}
